import { addLocaleData } from 'react-intl';
import enLang from './en_US';
import frLang from './fr_BE';
import nlLang from './nl_BE';
import momentEn from './en_US/moment';
import momentFr from './fr_BE/moment';
import momentNl from './nl_BE/moment';

const AppLocale = {
    en: enLang,
    fr: frLang,
    nl: nlLang,
};

Object.keys(AppLocale).forEach((key) => {
    addLocaleData(AppLocale[key].data);
});

momentEn();
momentFr();
momentNl();

export default AppLocale;
